import { render, staticRenderFns } from "./student.vue?vue&type=template&id=f7dd5558&scoped=true&"
import script from "./student.vue?vue&type=script&lang=js&"
export * from "./student.vue?vue&type=script&lang=js&"
import style0 from "./student.vue?vue&type=style&index=0&lang=css&"
import style1 from "./student.vue?vue&type=style&index=1&id=f7dd5558&scoped=true&lang=css&"
import style2 from "./student.vue?vue&type=style&index=2&lang=scss&"
import style3 from "./student.vue?vue&type=style&index=3&id=f7dd5558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7dd5558",
  null
  
)

export default component.exports